module.exports = __webpack_public_path__ + "static/img/zoom-max.76b86ad4.svg";